import { sendEventsBatched } from '../api/storiesApi'
import type { StoryLoadFailReason } from '../analytics'

/** Ошибка запроса в терминах контракта аналитики. */
interface RequestErrorShape {
  response?: { status?: number }
  code?: string
  message?: string
}

/** По ошибке запроса определяет reason для story_load_failed. */
export const loadFailReason = (error: unknown): StoryLoadFailReason => {
  const e = (error ?? {}) as RequestErrorShape
  const status = e.response?.status
  // Ответ пришёл — виноват бэкенд (или запрос), это server.
  if (typeof status === 'number') return 'server'
  if (e.code === 'ECONNABORTED' || e.code === 'ETIMEDOUT') return 'timeout'
  if (e.code === 'ERR_NETWORK' || e.message === 'Network Error') return 'network'
  if (error instanceof SyntaxError) return 'parse'
  return 'unknown'
}

/**
 * Лента или история не загрузилась. Уходит сразу отдельным запросом: общих
 * полей просмотрщика здесь нет, view_session_id ещё не создан.
 * @param error - ошибка запроса, из неё выводятся reason и http_status
 * @param storyId - id истории; не передаём, если не приехала вся лента
 */
export const trackStoryLoadFailed = (error: unknown, storyId?: number) => {
  const status = (error as RequestErrorShape | undefined)?.response?.status
  sendEventsBatched([
    {
      name: 'story_load_failed',
      reason: loadFailReason(error),
      ...(storyId != null ? { story_id: storyId } : {}),
      ...(typeof status === 'number' ? { http_status: status } : {}),
    },
  ])
}
